import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {
    NavButtons,
    RightFrame,
    ModalMain,
    ModalMainIllustrationContainer,
} from 'shells/modal/step-modal/layout';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalTitle} from 'shells/typography/modal-title';

import {trackModalPageLoad} from './track-page-load';

type Props = {
    onCancel: () => void;
    currentUrl: string;
};

export function GettingStarted(props: Props) {
    React.useEffect(() => {
        trackModalPageLoad(props.currentUrl);
    }, [props.currentUrl]);

    return (
        <RightFrame>
            <ModalMain>
                <ModalMainIllustrationContainer>
                    <Illustration src='trial-onboarding/email-sync-onboarding' width={280} />
                </ModalMainIllustrationContainer>
                <ModalHeader>Get started</ModalHeader>
                <Stack spacing={12}>
                    <div>
                        <ModalTitle lessBottomMargin={true}>Send & automate emails</ModalTitle>
                        <ModalBody>
                            Design emails using templates or AI, use follow-ups and automate emails
                            to leads in your pipeline.
                        </ModalBody>
                    </div>
                    <div>
                        <ModalTitle lessBottomMargin={true}>Track engagement</ModalTitle>
                        <ModalBody>
                            Track email activity in real time, including opens and clicks.
                        </ModalBody>
                    </div>
                    <div>
                        <ModalTitle lessBottomMargin={true}>Sync your inbox</ModalTitle>
                        <ModalBody>
                            Connect and sync your inbox to share conversations and automatically
                            create people.
                        </ModalBody>
                    </div>
                </Stack>
            </ModalMain>
            <NavButtons>
                <React.Fragment>
                    <Button variant='text' onClick={props.onCancel}>
                        Cancel
                    </Button>
                    <Link
                        variant='button-primary'
                        size='big'
                        // @ts-expect-error
                        as={RoutedLink}
                        to='/connect-email/choose-provider'
                    >
                        Start
                    </Link>
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
